import React, {useEffect} from 'react';
import GenericApi from "@/api/genericApi.tsx";
import {useNavigate} from "react-router-dom";
import {RoutesPathList} from "@/config/routes/Routes.tsx";
import {ApiRoutes} from "@/config/routes/ApiRoutes.tsx";

const ActivateUserPage: React.FC = () => {

  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const userId = urlParams.get('user_id');

    if (token && userId) {

      GenericApi.get(`${ApiRoutes.ACTIVATE_USER}/${userId}/${token}`)
        .then(() => {
          navigate(RoutesPathList.ActivateSuccess, { replace: true });
        })
        .catch(error => {
          console.error('Error activating user:', error);
          alert('Error activating user. Please try again later.');
        });
    }else {
        console.error('Token or user ID not found in URL');
        alert('Token or user ID not found in URL');
    }
  }, []);

  return <div className='flex h-[100dvh] justify-center items-center w-full'>Verifying account activation...</div>;
};

export default ActivateUserPage;
